export default __webpack_public_path__ + "static/media/ic_info.713a62e6.svg";